var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalDialog',{attrs:{"title":_vm.$t('indicators.new_measure_modal'),"showModalDialog":_vm.show,"fields_to_collect":_vm.fields,"submit_button_text":_vm.$t('dialog.save'),"unit":_vm.current_unit,"validate":""},on:{"close-dialog":_vm.close,"submit":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }